import { SlotRebuildTrigger } from 'services/selfSchedulingServices';

/** MM-1169: how each trigger is shown in the "Trigger type" column. */
export const TRIGGER_LABELS: Record<SlotRebuildTrigger, string> = {
  NIGHTLY: 'Nightly full rebuild',
  TEMPLATE_SAVE: 'Template save',
  SYNC_CALENDAR: 'Manual Sync Calendar',
  ADMIN_RESET: 'Admin reset',
  // MM-1198: a DrChrono break was added, changed or removed and its free slots rebuilt
  BREAK_UPDATE: 'Break change',
};
